module.exports = __webpack_public_path__ + "static/media/lr.ec8ad579.svg";